"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterHasUsedMobileApp = void 0;

require("core-js/modules/es.array.filter.js");

// Adding trivial comment to test publishing
var filterHasUsedMobileApp = function filterHasUsedMobileApp(stats) {
  if (!stats.used_platform_types) {
    return false;
  }

  var mobilePlatforms = stats.used_platform_types.filter(function (p) {
    return p === 'ANDROID_WEDDING_APP' || p === 'IPHONE_APP';
  });
  return (mobilePlatforms === null || mobilePlatforms === void 0 ? void 0 : mobilePlatforms.length) > 0;
};

exports.filterHasUsedMobileApp = filterHasUsedMobileApp;